/**
 * SLIDERS
 */
export function initSwiper() {
  // Buscamos todos los elementos que tengan la clase de nuestra galería
  const swiperElements = document.querySelectorAll(".swiper-galeria");

  swiperElements.forEach((element, index) => {
    const customDelay = element.getAttribute("data-autoplay-delay")
      ? parseInt(element.getAttribute("data-autoplay-delay"), 10)
      : 4000 + index * 1500;

    new Swiper(element, {
      spaceBetween: 0,
      centeredSlides: false,
      speed: 900,
      slideToClickedSlide: true,
      loop: true,
      slidesPerView: 1,
      allowTouchMove: true,
      autoplay: {
        delay: customDelay,
        disableOnInteraction: false,
        reverseDirection: true,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      breakpoints: {
        640: {
          spaceBetween: 0,
          slidesPerView: 1,
        },
      },
    });
  });

  // =====================================================
  // HABITACIONES
  // =====================================================

  (function () {
    if (window.innerWidth < 768) return;
    const carousel = document.getElementById("wheelCarousel");
    const stage = document.getElementById("wheelStage");
    const prevBtn = document.getElementById("wheelPrev");
    const nextBtn = document.getElementById("wheelNext");
    if (!carousel || !stage) return;

    let draggable = null;
    let wasDragged = false;
    let isDragging = false;
    let isHovering = false;
    let autoplay = null;

    const cards = carousel.querySelectorAll(".room-card");
    const slots = carousel.querySelectorAll(".wheel-slot");

    // =====================================================
    // ÁNGULO SEGÚN CANTIDAD DE HABITACIONES
    // =====================================================

    function getAngleStep() {
      const items = slots.length;
      return items ? 360 / items : 0;
    }

    function updateAngleStep() {
      const step = getAngleStep();
      stage.style.setProperty("--angle-step", `${step}deg`);
      return step;
    }

    // =====================================================
    // CARD CENTRAL
    // =====================================================

    function updateCenterCard() {
      const step = getAngleStep();
      const rotation = gsap.getProperty(carousel, "rotation") || 0;

      let closestCard = null;
      let closestDistance = Infinity;

      slots.forEach((slot, index) => {
        const card = slot.querySelector(".room-card");
        if (!card) return;

        let angle = index * step + rotation;

        angle = ((angle + 180) % 360) - 180;

        const distance = Math.abs(angle);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestCard = card;
        }
      });

      cards.forEach((card) => {
        card.classList.remove("is-center");
      });

      if (closestCard) {
        closestCard.classList.add("is-center");
      }
    }

    // =====================================================
    // DRAGGABLE
    // =====================================================

    function initDraggable() {
      if (draggable) {
        draggable.kill();
      }

      updateAngleStep();

      draggable = Draggable.create(carousel, {
        type: "rotation",
        inertia: true,
        minimumMovement: 2,
        onDragStart: () => {
          wasDragged = false;
          isDragging = true;
          stopAutoplay();
        },
        onDrag: () => {
          wasDragged = true;
          updateCenterCard();
        },
        onThrowUpdate: () => {
          updateCenterCard();
        },
        onThrowComplete: () => {
          isDragging = false;
          updateCenterCard();
          resumeAutoplay();
        },
        onDragEnd: () => {
          isDragging = false;
          updateCenterCard();
          if (!draggable.isThrowing) {
            resumeAutoplay();
          }
        },
        snap: function (endValue) {
          const step = getAngleStep();
          return Math.round(endValue / step) * step;
        },
      })[0];

      updateCenterCard();
    }

    // =====================================================
    // HOVER
    // =====================================================

    cards.forEach((card) => {
      card.addEventListener("mouseenter", () => {
        isHovering = true;
        stopAutoplay();
      });

      card.addEventListener("mouseleave", () => {
        isHovering = false;
        resumeAutoplay();
      });

      card.addEventListener("click", (e) => {
        if (wasDragged) {
          e.preventDefault();
          e.stopPropagation();
        }

        wasDragged = false;
      });
    });

    // =====================================================
    // ROTAR UN PASO
    // =====================================================

    function rotateStep(direction) {
      if (!draggable) return;

      const step = getAngleStep();
      const current = gsap.getProperty(carousel, "rotation") || 0;
      const target = current + direction * step;

      gsap.to(carousel, {
        rotation: target,
        duration: 0.7,
        ease: "power3.inOut",
        overwrite: true,
        onUpdate: updateCenterCard,
        onComplete: () => {
          draggable.update();
          updateCenterCard();
        },
      });
    }

    // =====================================================
    // AUTOPLAY
    // =====================================================

    function startAutoplay() {
      if (autoplay || isHovering || isDragging) return;

      autoplay = gsap.delayedCall(3, function tick() {
        autoplay = null;

        if (!isHovering && !isDragging) {
          rotateStep(1);
          startAutoplay();
        }
      });
    }

    function stopAutoplay() {
      if (autoplay) {
        autoplay.kill();
        autoplay = null;
      }
    }

    function resumeAutoplay() {
      if (isHovering || isDragging) return;

      stopAutoplay();
      startAutoplay();
    }

    // =====================================================
    // FLECHAS
    // =====================================================

    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        stopAutoplay();
        rotateStep(-1);
        resumeAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        stopAutoplay();
        rotateStep(1);
        resumeAutoplay();
      });
    }

    // =====================================================
    // RESIZE
    // =====================================================

    let resizeTimer;
    let lastWidth = window.innerWidth;

    window.addEventListener("resize", () => {
      const currentWidth = window.innerWidth;

      if (Math.abs(currentWidth - lastWidth) < 5) {
        return;
      }

      lastWidth = currentWidth;

      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        initDraggable();
        restartAutoplay();
      }, 250);
    });

    // =====================================================
    // INIT
    // =====================================================

    initDraggable();
    startAutoplay();
  })();

  let habitacionesMobile = null;

  function initHabitacionesMobile() {
    const slider = document.querySelector(".habitaciones-mobile");

    if (!slider) return;

    if (window.innerWidth < 768) {
      if (habitacionesMobile) return;

      const sideOffset = window.innerWidth * 0.07;
      const pagination = slider.querySelector(
        ".habitaciones-mobile__pagination",
      );
      const slides = slider.querySelectorAll(".swiper-slide");

      pagination.innerHTML = "";

      slides.forEach((slide, index) => {
        const bullet = document.createElement("button");

        bullet.classList.add("habitaciones-bullet");

        if (index === 0) {
          bullet.classList.add("active");
        }

        bullet.addEventListener("click", () => {
          habitacionesMobile.slideTo(index);
        });

        pagination.appendChild(bullet);
      });

      habitacionesMobile = new Swiper(slider, {
        slidesPerView: 1.12,
        spaceBetween: 14,
        slidesOffsetBefore: sideOffset,
        slidesOffsetAfter: sideOffset,
        speed: 650,
        grabCursor: true,
        watchSlidesProgress: true,

        on: {
          slideChange(swiper) {
            const index = Math.min(swiper.activeIndex, slides.length - 1);

            pagination
              .querySelectorAll(".habitaciones-bullet")
              .forEach((bullet, i) => {
                bullet.classList.toggle("active", i === index);
              });
          },
        },
      });
    } else {
      if (habitacionesMobile) {
        habitacionesMobile.destroy(true, true);
        habitacionesMobile = null;
      }
    }
  }

  initHabitacionesMobile();

  let habitacionesResizeTimer;
  let habitacionesLastWidth = window.innerWidth;

  window.addEventListener("resize", () => {
    const currentWidth = window.innerWidth;

    if (Math.abs(currentWidth - habitacionesLastWidth) < 10) return;

    habitacionesLastWidth = currentWidth;

    clearTimeout(habitacionesResizeTimer);

    habitacionesResizeTimer = setTimeout(() => {
      initHabitacionesMobile();
    }, 250);
  });

  const caracteristicasSwiper = new Swiper(".swiper-caracteristicas", {
    effect: "fade",

    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 30000,
      disableOnInteraction: false,
      reverseDirection: true,
    },
    navigation: {
      nextEl: ".swiper-caracteristicas .arrows-container .next",
      prevEl: ".swiper-caracteristicas .arrows-container .prev",
    },

    speed: 1200,

    loop: true,

    pagination: {
      el: ".swiper-caracteristicas .swiper-pagination",
      clickable: true,
    },

    on: {
      init(swiper) {
        initCaracteristicaSlide(swiper.slides[swiper.activeIndex]);
      },

      slideChangeTransitionStart(swiper) {
        const currentSlide = swiper.slides[swiper.previousIndex];
        const nextSlide = swiper.slides[swiper.activeIndex];

        leaveCaracteristicaSlide(currentSlide);
        prepareCaracteristicaSlide(nextSlide);
      },

      slideChangeTransitionEnd(swiper) {
        const activeSlide = swiper.slides[swiper.activeIndex];

        enterCaracteristicaSlide(activeSlide);
      },
    },
  });

  function getSlideLines(slide) {
    return slide.querySelectorAll(
      ".slide-title h2 .line, " +
        ".slide-subtitle .line, " +
        ".slide-text p .line",
    );
  }
  function splitCaracteristicaSlide(slide) {
    const elements = slide.querySelectorAll(
      ".slide-title h2, .slide-subtitle, .slide-text",
    );

    elements.forEach((element) => {
      if (element.dataset.split === "true") {
        return;
      }

      new SplitText(element, {
        type: "lines",
        linesClass: "line",
      });

      element.dataset.split = "true";
    });
  }
  function initCaracteristicaSlide(slide) {
    splitCaracteristicaSlide(slide);

    const lines = getSlideLines(slide);

    gsap.set(lines, {
      yPercent: 100,
      opacity: 0,
    });

    enterCaracteristicaSlide(slide);
  }
  function splitCaracteristicaSlide(slide) {
    const elements = slide.querySelectorAll(
      ".slide-title h2, .slide-subtitle, .slide-text p",
    );

    elements.forEach((element) => {
      if (element.dataset.split === "true") {
        return;
      }

      new SplitText(element, {
        type: "lines",
        linesClass: "line",
      });

      element.dataset.split = "true";
    });
  }
  function enterCaracteristicaSlide(slide) {
    splitCaracteristicaSlide(slide);

    const linea = slide.querySelector(".linea-titulo");

    const titleLines = slide.querySelectorAll(".slide-title h2 .line");
    const subtitleLines = slide.querySelectorAll(".slide-subtitle .line");
    const paragraphs = slide.querySelectorAll(".slide-text p");

    const tl = gsap.timeline();

    // Línea
    tl.to(linea, {
      scaleX: 1,
      duration: 1,
      ease: "power3.inOut",
    })
      // Título
      .to(
        titleLines,
        {
          yPercent: 0,
          opacity: 1,
          duration: 0.9,
          stagger: 0.08,
          ease: "power4.out",
        },
        "-=.55",
      )
      // Subtítulo
      .to(
        subtitleLines,
        {
          yPercent: 0,
          opacity: 1,
          duration: 0.7,
          stagger: 0.04,
          ease: "power3.out",
        },
        "-=.55",
      );

    // Párrafos
    paragraphs.forEach((paragraph, index) => {
      const lines = paragraph.querySelectorAll(".line");

      tl.to(
        lines,
        {
          yPercent: 0,
          opacity: 1,
          duration: 0.7,
          stagger: 0.025,
          ease: "power3.out",
        },
        index === 0 ? "-=.35" : "-=.45",
      );
    });
  }

  function leaveCaracteristicaSlide(slide) {
    if (!slide) return;

    const lines = getSlideLines(slide);
    const linea = slide.querySelector(".linea-titulo");

    const tl = gsap.timeline();

    tl.to(lines, {
      yPercent: -100,
      opacity: 0,
      duration: 0.65,
      stagger: 0.02,
      ease: "power3.in",
    }).to(
      linea,
      {
        scaleX: 0,
        duration: 0.6,
        ease: "power3.inOut",
      },
      "-=.5",
    );
  }

  function prepareCaracteristicaSlide(slide) {
    if (!slide) return;

    splitCaracteristicaSlide(slide);

    const lines = getSlideLines(slide);
    const linea = slide.querySelector(".linea-titulo");

    gsap.set(lines, {
      yPercent: 100,
      opacity: 0,
    });

    gsap.set(linea, {
      scaleX: 0,
      transformOrigin: "left center",
    });
  }
}

export function initMarqueeDrag() {
  if (window.innerWidth < 768) return;
  document.querySelectorAll(".slider_actividad.marquee").forEach((slider) => {
    const marquee = slider.querySelector(".marquee-inner");
    const lists = marquee ? marquee.querySelectorAll(".marquee-list") : [];
    if (!marquee || lists.length < 2) return;
    let isDragging = false;
    let isHovering = false;
    let startX = 0;
    let startPosition = 0;
    let currentPosition = 0;
    let animationFrame;
    let lastTime = null;
    let moved = false;
    const speed = 40;
    const getListWidth = () => lists[0].getBoundingClientRect().width;
    const normalizePosition = () => {
      const width = getListWidth();
      if (!width) return;
      while (currentPosition <= -width) currentPosition += width;
      while (currentPosition > 0) currentPosition -= width;
    };
    const animate = (time) => {
      if (lastTime === null) lastTime = time;
      const delta = (time - lastTime) / 1000;
      lastTime = time;
      if (!isDragging && !isHovering) {
        currentPosition -= speed * delta;
        normalizePosition();
        marquee.style.transform = `translate3d(${currentPosition}px, 0, 0)`;
      }
      animationFrame = requestAnimationFrame(animate);
    };
    const startAnimation = () => {
      cancelAnimationFrame(animationFrame);
      lastTime = null;
      animationFrame = requestAnimationFrame(animate);
    };
    marquee.style.animation = "none";
    currentPosition = 0;
    marquee.style.transform = "translate3d(0, 0, 0)";
    startAnimation();
    slider.addEventListener("mouseenter", () => {
      if (!isDragging) {
        isHovering = true;
        slider.classList.add("is-hovering");
      }
    });
    slider.addEventListener("mouseleave", () => {
      isHovering = false;
      slider.classList.remove("is-hovering");
      lastTime = null;
    });
    marquee.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      isDragging = true;
      isHovering = false;
      moved = false;
      startX = e.clientX;
      startPosition = currentPosition;
      slider.classList.add("is-dragging");
      e.preventDefault();
    });
    window.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      const delta = e.clientX - startX;
      if (Math.abs(delta) > 5) moved = true;
      currentPosition = startPosition + delta;
      normalizePosition();
      marquee.style.transform = `translate3d(${currentPosition}px, 0, 0)`;
    });
    window.addEventListener("mouseup", () => {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove("is-dragging");
      lastTime = null;
    });
    marquee.addEventListener(
      "touchstart",
      (e) => {
        const touch = e.touches[0];
        isDragging = true;
        isHovering = false;
        moved = false;
        startX = touch.clientX;
        startPosition = currentPosition;
        slider.classList.add("is-dragging");
      },
      { passive: true },
    );
    marquee.addEventListener(
      "touchmove",
      (e) => {
        if (!isDragging) return;
        const touch = e.touches[0];
        const delta = touch.clientX - startX;
        if (Math.abs(delta) > 5) moved = true;
        currentPosition = startPosition + delta;
        normalizePosition();
        marquee.style.transform = `translate3d(${currentPosition}px, 0, 0)`;
      },
      { passive: true },
    );
    marquee.addEventListener("touchend", () => {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove("is-dragging");
      lastTime = null;
    });
    marquee.addEventListener(
      "click",
      (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true,
    );
  });
}
export function initGaleriaMobile() {
  const sliders = document.querySelectorAll(".galeria-mobile");

  sliders.forEach((slider) => {
    if (window.innerWidth >= 768) return;

    if (slider.swiper) return;

    const pagination = slider.querySelector(".galeria-mobile__pagination");
    const slides = slider.querySelectorAll(".swiper-slide");

    if (!slides.length) return;

    pagination.innerHTML = "";

    slides.forEach((slide, index) => {
      const bullet = document.createElement("button");

      bullet.type = "button";
      bullet.classList.add("galeria-mobile__bullet");

      if (index === 0) {
        bullet.classList.add("active");
      }

      bullet.setAttribute("aria-label", `Ir a imagen ${index + 1}`);

      pagination.appendChild(bullet);
    });

    const bullets = pagination.querySelectorAll(".galeria-mobile__bullet");

    const sideOffset = window.innerWidth * 0.07;

    const swiper = new Swiper(slider, {
      slidesPerView: 1.12,
      spaceBetween: 14,

      slidesOffsetBefore: sideOffset,
      slidesOffsetAfter: sideOffset,

      speed: 650,
      grabCursor: true,
      watchSlidesProgress: true,

      navigation: {
        nextEl: slider.querySelector(".galeria-mobile__next"),
        prevEl: slider.querySelector(".galeria-mobile__prev"),
      },

      on: {
        slideChange(swiper) {
          const index = Math.min(swiper.activeIndex, slides.length - 1);

          bullets.forEach((bullet, i) => {
            bullet.classList.toggle("active", i === index);
          });
        },
      },
    });

    bullets.forEach((bullet, index) => {
      bullet.addEventListener("click", () => {
        swiper.slideTo(index);
      });
    });
  });
}
